import { useEffect, useState } from 'react';
import { getLiveUiMessages, type LiveUiMessages } from './liveEntryGuard';

export function useLiveUiMessages(): LiveUiMessages {
  const [messages, setMessages] = useState<LiveUiMessages>({
    loginRequired: '로그인후 이용해주세요',
    enterBlocked: '코인 및 등급 부족하여 입장할수 없습니다',
    broadcastPending: '관리자 승인후 방송가능 합니다.',
  });

  useEffect(() => {
    let mounted = true;
    void getLiveUiMessages().then((next) => {
      if (mounted) setMessages(next);
    });
    return () => { mounted = false; };
  }, []);

  return messages;
}
